import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { ToasterService } from 'angular2-toaster';
import 'rxjs/add/operator/toPromise';

import { ClientModel } from '../model/index';

@Injectable()
export class ClientService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private clientUrl = 'api/client';  // URL to web api

    constructor(private http: Http, public toasterService: ToasterService) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getClientList(query: any): Promise<ClientModel[]> {
        let that = this,
            params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.clientUrl}/clientList`;
        return this.http.get(url, options)
            .toPromise()
            .then(that.extractData,
            // Errors will call this callback instead:
            err => {
                var toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'Something went wrong!'
                };
                that.toasterService.pop(toast);
            })
            .catch(this.handleError);
    }

    getClient(client_id: number): Promise<ClientModel> {
        const url = `${this.clientUrl}/clientList?client_id=${client_id}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as ClientModel)
            .catch(this.handleError);
    }

    deleteClient(client_id: any): Promise<ClientModel> {
        const url = `${this.clientUrl}/deleteClient`;
        return this.http
            .post(url, $.param({ client_id: client_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ClientModel)
            .catch(this.handleError);
    }

    addUpdateClient(clientData: any): Promise<any> {
        const url = `${this.clientUrl}/addUpdateClient`;
        return this.http
            .post(url, $.param(clientData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    deletePhoto(agentData: any): Promise<any> {
        const url = `${this.clientUrl}/deletePhoto`;
        return this.http
            .post(url, $.param(agentData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getClientConversionList(data: any): Promise<ClientModel> {
        const url = `${this.clientUrl}/getClientConversionList`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    combineClientData(data: any): Promise<ClientModel> {
        const url = `${this.clientUrl}/combineClientData`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getClientConversionHistory(data: any): Promise<ClientModel[]> {
        const url = `${this.clientUrl}/getClientConversionHistory`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    searchRefClients(data: any): Promise<any> {
        const url = `${this.clientUrl}/searchRefClients`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    searchRefEmployees(data: any): Promise<any> {
        const url = `${this.clientUrl}/searchRefEmployees`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }


    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/client.service.ts